import React from "react";
import data from "../json/Allproducts/Xpertreview.json";
import Section1 from "../components/Allproducts/Section1";
import Section2 from "../components/Allproducts/Section2";
import Section4 from "../components/Allproducts/Section4";
import SEO from "../components/SEO";

const xpertReviewSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "XPERT Review1",
  "brand": {
    "@type": "Brand",
    "name": "Transforma Pvt Ltd"
  },
  "url": "https://www.transforma.in/products/xpertreview",
  "logo": "https://www.transforma.in/images/transformalogo.svg",
  "description": "XPERT Review is an advanced, AI-powered submission and peer review platform designed to streamline the manuscript review process with features like automated reviewer matching and real-time tracking.",
  "offers": {
    "@type": "Offer",
    "priceCurrency": "USD",
    "url": "https://www.transforma.in/products/xpertreview"
  }
};

const Xpertreview = () => {
  return (
    <>
    <SEO
        title="XPERT Review | AI-Powered Submission & Peer Review Platform"
        description="Streamline manuscript management with XPERT Review. Features AI-driven reviewer matching, customizable templates, workflow management, and real-time tracking."
        keywords="XPERT Review, peer review platform, AI reviewer matching, manuscript submission system, workflow management, journal peer review tool, editorial analytics, scholarly publishing software"
        canonical="https://www.transforma.in/products/xpertreview" 
        schema={xpertReviewSchema}
      /> 
    <div className="w-full flex flex-col items-center ruler">

      <Section1 data={data}/>
      <Section2 data={data.Section3}/>
      <Section4 data={data.Section4}/>
    </div>
    </>
  );
};

export default Xpertreview;
